import { useEffect } from 'react';

const BASE = 'Study Buddy';

/**
 * Sets document.title for the lifetime of the calling component, restoring
 * the previous title on unmount. Pass a short page label — base suffix is
 * appended automatically. Pass null/undefined to leave the title untouched.
 */
export function useDocumentTitle(label?: string | null): void {
  useEffect(() => {
    if (!label) return;
    const prev = document.title;
    document.title = `${label} · ${BASE}`;
    return () => { document.title = prev; };
  }, [label]);
}
